export const handleDownloadFile = async (url: string, filename: string) => {
  try {
    const res = await fetch(url)
    if (!res.ok) throw new Error('Falha ao baixar')
    const blob = await res.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(blobUrl)
  } catch (err) {
    console.error('Erro no download:', err)
  }
}
